import { createSlice } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";

import * as actions from "./Actions";

const initialState = {
  isLoading: false,
  error: "",
  success: false,
  data: {},
};

const YogaProgramPageSlice = createSlice({
  name: "YogaProgramPage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //HYDRATE
      .addCase(HYDRATE, (state, { payload }) => ({
        ...state,
        ...payload.yogaProgram,
      }))
      // GET HEALTH LANDING PAGE
      .addCase(actions.getYogaProgramPage.pending, (state) => ({
        ...state,
        isLoading: true,
        success: false,
        error: "",
      }))
      .addCase(actions.getYogaProgramPage.fulfilled, (state, { payload }) => {
        return {
          ...state,
          isLoading: false,
          success: true,
          data: payload?.data,
        };
      })
      .addCase(actions.getYogaProgramPage.rejected, (state, { payload }) => ({
        ...state,
        isLoading: false,
        error: payload?.error || null,
      }));
  },
});

export { getYogaProgramPage } from "./Actions";

export default YogaProgramPageSlice.reducer;
